"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Delete = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const Base_1 = require("./Base");
const Delete = ({ fill = "#E6E6E6", size = 16, }) => (react_1.default.createElement(Base_1.Base, { size: size },
    react_1.default.createElement("path", { fill: fill, d: "M3,5v2l1,1v7q4,2,8,0V8l1-1V5zM7,13H6V8h1V13zM10,13H9V8h1V13zM11,3V1L10,1H5V3H2v1h12V3H11zM6,3V2h4V3" })));
exports.Delete = Delete;
//# sourceMappingURL=Delete.js.map